import request from '@utils/request'
const url = 'api/switch/'

/**
 * 1S闪闭功能 （关=>1S开=>关）
 * @param {*} data
 */
export function ChannelFlashOpen (data) {
  return request({
    url: url + 'ChannelFlashOpen',
    method: 'post',
    data
  })
}

/**
 * 获取继电器状态和指示灯状态
 * @param {*} data
 */
export function QueryChannelStatusAndIndicatorStatus (data) {
  return request({
    url: url + 'QueryChannelStatusAndIndicatorStatus',
    method: 'post',
    data
  })
}

/**
 * 分页获取开关设备
 * @param {*} data
 * @returns
 */
export function PageQuerySwitch (data) {
  return request({
    url: url + 'PageQuerySwitch',
    method: 'post',
    data
  })
}

/**
 *添加开关[串口断路器]
 * @param { orgid: string, gatewaysn: string, switchalias: string } data
 */
export function AddSwitch (data) {
  return request({
    url: url + 'AddSwitch',
    method: 'post',
    data
  })
}

/**
 *修改开关别名
 * @param {  deviceid: string, alias: string } data
 */
export function UpdateSingleSwitchAlias (data) {
  return request({
    url: url + 'UpdateSingleSwitchAlias',
    method: 'post',
    data
  })
}

/**
 * 移除串口断路器
 * @param { deviceid: string, operatepassword: string } data
 */
export function DeleteSwitch (data) {
  return request({
    url: url + 'DeleteSwitch',
    method: 'post',
    data
  })
}

/**
 * 校验串口断路器操作码
 * @param {deviceid: string, operatepassword:string} data
 * @returns
 */
export function ValidateOperateCode (data) {
  return request({
    url: url + 'ValidateOperateCode',
    method: 'post',
    data
  })
}

/** 发送操作码到手机 */
export function SendOperateCode (data) {
  return request({
    url: url + 'SendOperateCode',
    method: 'post',
    data
  })
}

/** 发送操作码到邮箱 */
export function SendOperateCodeToEmail (data) {
  return request({
    url: url + 'SendOperateCodeToEmail',
    method: 'post',
    data
  })
}
